import { Box, Typography } from "@mui/material";
import React from "react";
import TestimonialCard from "../TestimonialCard";
import type { Testimonial } from "../../content/roleFaqsContent";
import { Reveal, StaggerGroup } from "../../theme/animation";

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
  id?: string;
}

const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({
  testimonials,
  id = "testimonials",
}) => {
  if (!testimonials?.length) return null;

  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Reveal variant="fadeUp">
        <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
          Testimonials
        </Typography>
      </Reveal>
      <StaggerGroup stagger={0.1}>
        {testimonials.map((t, i) => (
          <Reveal key={i} variant="fadeUp" staggerIndex={i}>
            <Box sx={{ mb: 2 }}>
              <TestimonialCard testimonial={t} sx={{ mb: 0 }} />
            </Box>
          </Reveal>
        ))}
      </StaggerGroup>
    </Box>
  );
};

export default TestimonialsSection;
